// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Fp-z","imageAndVideoCount":"Gp-z","imageAndVideoContainer":"Hp-z","viewAllReviews":"Ip-z"};